import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import {
  nonNullable,
  type EditorSDK,
} from '@wix/wix-data-client-common-standalone'
import { ROUTER_DATASET } from '@wix/wix-data-client-common'

export async function fetchRouterDatasetFromPage(
  editorSdkProxy: EditorSDK,
  pageRef: ComponentRef,
) {
  const pageControllerRefs = await editorSdkProxy.controllers.listControllers({
    pageRef,
  })
  for (const { controllerRef } of pageControllerRefs) {
    const controllerData = await editorSdkProxy.controllers.getData({
      controllerRef,
    })
    if (controllerData.type === ROUTER_DATASET) {
      return {
        ref: controllerRef,
        data: controllerData,
      }
    }
  }
  return null
}

// A page may have multiple router datasets because of data corruption (see WD-8682)
export async function fetchAllRouterDatasetRefsFromPage(
  editorSdkProxy: EditorSDK,
  pageRef: ComponentRef,
): Promise<ComponentRef[]> {
  const allDatasetRefs = await editorSdkProxy.controllers.listControllers({
    pageRef,
  })
  const routerDatasetRefs = await Promise.all(
    allDatasetRefs.map(async ({ controllerRef }) => {
      const { type } = await editorSdkProxy.controllers.getData({
        controllerRef,
      })
      return type === ROUTER_DATASET ? controllerRef : null
    }),
  )
  return routerDatasetRefs.filter(nonNullable)
}
